import React from 'react';
import { calculateFinalPrice, calculateItemTotal, calculateCartTotal } from '../../utils/priceUtils';
import './OrderItemsSummary.css';

const OrderItemsSummary = ({ cartItems }) => {
  if (!cartItems || cartItems.length === 0) {
    return null;
  }

  const totalAmount = calculateCartTotal(cartItems);

  return (
    <div className="order-items-summary">
      <div className="summary-header">
        <h3>Order Summary</h3>
        <span className="item-count">{cartItems.length} {cartItems.length === 1 ? 'item' : 'items'}</span>
      </div>
      
      <div className="summary-items">
        {cartItems.map((item, index) => {
          const finalPrice = calculateFinalPrice(item.sales_price, item.sales_discount || 0);
          const itemTotal = calculateItemTotal(item);
          
          return (
            <div key={item.id || item.item_id || index} className="summary-item">
              <div className="item-image">
                <img 
                  src={item.item_image_url || item.img || '/assets/images/products/p.png'} 
                  alt={item.item_name || 'Product'} 
                  onError={(e) => e.target.src = '/assets/images/products/p.png'}
                />
              </div>
              <div className="item-details">
                <h4 className="item-name">{item.item_name || 'Product'}</h4>
                <div className="item-meta">
                  {item.item_code && <span className="item-code">Code: {item.item_code}</span>}
                  {item.unit_name && <span className="item-unit">Unit: {item.unit_name}</span>}
                </div>
                <div className="item-price-info">
                  <span className="item-quantity">Qty: {item.quantity || 1}</span>
                  <span className="item-price">
                    ₹{finalPrice.toFixed(2)} × {item.quantity || 1} = ₹{itemTotal.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="summary-footer">
        <div className="total-amount">
          <span className="total-label">Total Amount:</span>
          <span className="total-value">₹{totalAmount.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderItemsSummary;

